<template>
  <section class="top">
    <TopHero />
  </section>
</template>

<script>
import TopHero from "./TopHero.vue";
export default {
  name: "Top",
  components: {
    TopHero,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      message: "Guerrilla Space　Demo",
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.top {
  padding-bottom: 50px;
}
</style>
